import Vue from 'vue';
import VueRouter from 'vue-router';
import { routes } from './routes';
//import { guardRoute, updatePageTitle } from './middlewares';
import { updatePageTitle } from './middlewares';

Vue.use(VueRouter);

const router = new VueRouter({
    routes,
    linkActiveClass: 'has-current'
});

//router.beforeEach(guardRoute);
router.beforeEach(updatePageTitle);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js